import createBaseFor from "./_createBaseFor.js";
var baseFor = createBaseFor();
export {
  baseFor as default
};
//# sourceMappingURL=_baseFor.js.map
